import { BookIcon, CalendarIcon, LocationIcon } from 'assets/icons';
import { AlbumContentType } from 'common/enums';
import { adaptContentType, classnames } from 'helpers/utils';
import { AlbumContentSerialized } from 'networking/types/album-detail';
import { memoryDateLabel } from 'helpers/memory-date-label';
import styles from './details-panel.module.scss';

interface PublicDetailsPanelProps {
  content: AlbumContentSerialized | undefined;
  // The memory's album, when the page mixes several albums (the vault view).
  albumName?: string | null;
  // Phones: the fields under the memory, as on the owner's phone screen; the
  // location and date are under the title there.
  phone?: boolean;
}

// The details column of the public view mode: what DetailsPanel shows, as
// plain text, and only what's set. Nothing here can be edited.
export const PublicDetailsPanel = ({
  content,
  albumName,
  phone = false,
}: PublicDetailsPanelProps) => {
  if (!content) return null;

  const { location } = content;
  const dateLabel = memoryDateLabel(content.startDate, content.endDate);
  // Journal/text entries don't carry a separate description field.
  const description =
    adaptContentType(content) !== AlbumContentType.write
      ? content.description
      : '';

  if (phone && !albumName && !description) return null;

  return (
    <div className={classnames(styles.panel, { [styles.panelPage]: phone })}>
      {!phone && (location || dateLabel) && (
        <>
          <div className={styles.tags}>
            {location && (
              <span className={styles.tagStatic}>
                <LocationIcon className={styles.tagIcon} />
                <span className={styles.tagText}>{location}</span>
              </span>
            )}
            {dateLabel && (
              <span className={styles.tagStatic}>
                <CalendarIcon className={styles.tagIcon} />
                <span className={styles.tagText}>{dateLabel}</span>
              </span>
            )}
          </div>
          <div className={styles.divider} />
        </>
      )}

      {albumName && (
        <div className={styles.field}>
          <span className={styles.label}>{phone ? 'Albums' : 'Album'}</span>
          <div className={styles.albumChip}>
            <BookIcon className={styles.albumChipIcon} />
            <span className={styles.albumChipText}>{albumName}</span>
          </div>
        </div>
      )}

      {description && (
        <div className={classnames(styles.field, styles.descriptionField)}>
          <span className={styles.label}>Description</span>
          <p className={styles.descriptionStatic}>{description}</p>
        </div>
      )}
    </div>
  );
};
